import { createContext } from 'react';
import type { StoreApi } from 'zustand';

import { WithChildren } from '../../types/with-children.js';
import type { CalendarTimeframeStore } from './calendar.types.js';
import type { DateTimePickerValueStore } from './dateTimePicker.types.js';
import type { DateTimeRangePickerTimeframeStore } from './dateTimeRangePicker.types.js';
import type { TimeframeSelectorStore } from './timeframeSelector.types.js';

/** @internal */
export const CalendarStoreCtx =
  createContext<StoreApi<CalendarTimeframeStore> | null>(null);

/** @internal */
export const DateTimePickerStoreCtx =
  createContext<StoreApi<DateTimePickerValueStore> | null>(null);

/** @internal */
export const DateTimeRangePickerStoreCtx =
  createContext<StoreApi<DateTimeRangePickerTimeframeStore> | null>(null);

/** @internal */
export const TimeframeSelectorStoreCtx =
  createContext<StoreApi<TimeframeSelectorStore> | null>(null);

/** @internal */
export function CalendarStoreProvider({
  store,
  children,
}: WithChildren & { store: StoreApi<CalendarTimeframeStore> }) {
  return (
    <CalendarStoreCtx.Provider value={store}>
      {children}
    </CalendarStoreCtx.Provider>
  );
}

/** @internal */
export function DateTimePickerStoreProvider({
  store,
  children,
}: WithChildren & { store: StoreApi<DateTimePickerValueStore> }) {
  const calStore = store as unknown as StoreApi<CalendarTimeframeStore>;
  return (
    <CalendarStoreCtx.Provider value={calStore}>
      <DateTimePickerStoreCtx.Provider value={store}>
        {children}
      </DateTimePickerStoreCtx.Provider>
    </CalendarStoreCtx.Provider>
  );
}

/** @internal */
export function DateTimeRangePickerStoreProvider({
  store,
  children,
}: WithChildren & { store: StoreApi<DateTimeRangePickerTimeframeStore> }) {
  const calStore = store as unknown as StoreApi<CalendarTimeframeStore>;
  const dtpStore = store as unknown as StoreApi<DateTimePickerValueStore>;
  return (
    <CalendarStoreCtx.Provider value={calStore}>
      <DateTimePickerStoreCtx.Provider value={dtpStore}>
        <DateTimeRangePickerStoreCtx.Provider value={store}>
          {children}
        </DateTimeRangePickerStoreCtx.Provider>
      </DateTimePickerStoreCtx.Provider>
    </CalendarStoreCtx.Provider>
  );
}

/** @internal */
export function TimeframeSelectorStoreProvider({
  store,
  children,
}: WithChildren & { store: StoreApi<TimeframeSelectorStore> }) {
  const calStore = store as unknown as StoreApi<CalendarTimeframeStore>;
  const dtpStore = store as unknown as StoreApi<DateTimePickerValueStore>;
  const dtrpStore =
    store as unknown as StoreApi<DateTimeRangePickerTimeframeStore>;
  return (
    <CalendarStoreCtx.Provider value={calStore}>
      <DateTimePickerStoreCtx.Provider value={dtpStore}>
        <DateTimeRangePickerStoreCtx.Provider value={dtrpStore}>
          <TimeframeSelectorStoreCtx.Provider value={store}>
            {children}
          </TimeframeSelectorStoreCtx.Provider>
        </DateTimeRangePickerStoreCtx.Provider>
      </DateTimePickerStoreCtx.Provider>
    </CalendarStoreCtx.Provider>
  );
}
